import { createAction, props } from '@ngrx/store';

import { MyBrokersActionTypes } from './actions.model';

export const init = createAction(MyBrokersActionTypes.Init);

export const brokerSelected = createAction(
  MyBrokersActionTypes.BrokerSelected,
  props<{ id: string }>()
);

export const brokerDeselected = createAction(
  MyBrokersActionTypes.BrokerDeselected
);

export const destroyed = createAction(MyBrokersActionTypes.Destroyed);
